//==========import components===============
import TitleSection from 'components/common/TitleSection';
import EventDoCard from '../common/cards/EventDoCard';

const EventDo = ({ data }) => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'DE EVENTE DO',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section
      className='eventDoSec DBlock py-10 sm:py-12 px-6 sm:px-10'
      style={{
        background: `url("/assets/images/what-we-do/eventDoBg.png") no-repeat center/cover`,
      }}>
      <div className='max-w-7xl mx-auto '>
        <div className='grid grid-cols-1'>
          <TitleSection titleDetail={titleDetail} />
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'>
            {data?.map((list) => (
              <div key={`cardList${list?.id}`}>
                <EventDoCard data={list} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDo;
